import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-musical-comp',
  templateUrl: './musical-comp.component.html',
  styleUrls: ['./musical-comp.component.scss']
})
export class MusicalCompComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
